// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/IntegrationStagingRecord.yaml
// Generated: 2026-03-17T14:51:33.838Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateIntegrationStagingRecord, UpdateIntegrationStagingRecord, IntegrationStagingRecord } from '@/types/integration/IntegrationStagingRecord';

/**
 * IntegrationStagingRecord Service
 * CRUD operations for IntegrationStagingRecord via the ABP API.
 */
export const integrationStagingRecordService = new EntityService<IntegrationStagingRecord, CreateIntegrationStagingRecord, UpdateIntegrationStagingRecord>(
  '/api/integration/integrationstagingrecord',
  'IntegrationStagingRecord',
);
